import { X, Minus, Plus, Trash2, ArrowRight } from "lucide-react";
import { useCart } from "../lib/store";
import { CardArt } from "./CardArt";
import { useNavigate } from "react-router-dom";

export const CartDrawer = () => {
  const { items, open, setOpen, updateQty, remove, subtotal, balance, count, effectivePrice } = useCart();
  const navigate = useNavigate();
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-black/70" onClick={() => setOpen(false)} />
      <aside className="absolute right-0 top-0 bottom-0 w-full sm:w-[440px] bg-[#0b0b0d] border-l border-[#C9A227]/25 flex flex-col">
        <div className="flex items-center justify-between p-5 border-b border-[#C9A227]/20">
          <div>
            <div className="eyebrow">Il tuo carrello</div>
            <h3 className="font-display text-xl font-bold text-white mt-1">{count} articoli</h3>
          </div>
          <button onClick={() => setOpen(false)} data-testid="cart-close" className="p-2 text-white hover:text-[#C9A227]">
            <X size={20} />
          </button>
        </div>

        {items.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center px-6 text-center">
            <div className="w-16 h-16 rounded-sm border border-[#C9A227]/30 flex items-center justify-center text-[#C9A227] mb-4">
              <ArrowRight size={22} />
            </div>
            <div className="font-display text-lg text-white mb-1">Il carrello è vuoto</div>
            <div className="text-sm text-[#9CA3AF]">Aggiungi i tuoi prodotti TCG preferiti.</div>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto p-5 space-y-4">
              {items.map((i) => (
                <div key={i.product_id} data-testid={`cart-item-${i.slug}`} className="flex gap-3 border border-[#C9A227]/15 rounded-sm p-3 bg-[#121214]">
                  <div className="w-20 shrink-0">
                    {i.image_url ? (
                      <div className="w-full h-24 bg-[#0b0b0d] border border-[#C9A227]/25 overflow-hidden">
                        <img src={i.image_url.startsWith("http") ? i.image_url : `${process.env.REACT_APP_BACKEND_URL}${i.image_url}`} alt={i.name} className="w-full h-full object-cover" />
                      </div>
                    ) : (
                      <CardArt product={i} size="sm" />
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold text-white line-clamp-2">{i.name}</div>
                    <div className="text-[11px] font-mono-ps text-[#9CA3AF] uppercase tracking-widest mt-1">
                      {i.language?.toUpperCase() || "TCG"} {i.is_preorder ? "• PREORDER" : ""}
                      {i.preorder_type === "allocation-deposit" && ` • Acconto ${i.deposit_percent}%`}
                    </div>
                    <div className="flex items-center justify-between mt-2">
                      <div className="flex items-center border border-[#C9A227]/25 rounded-sm">
                        <button onClick={() => updateQty(i.product_id, i.qty - 1)} className="p-1.5 text-white hover:text-[#C9A227]"><Minus size={14} /></button>
                        <span className="w-8 text-center text-sm text-white font-mono-ps">{i.qty}</span>
                        <button onClick={() => updateQty(i.product_id, i.qty + 1)} data-testid={`cart-qty-plus-${i.slug}`} className="p-1.5 text-white hover:text-[#C9A227]"><Plus size={14} /></button>
                      </div>
                      <div className="flex items-center gap-3">
                        <span className="text-sm font-mono-ps font-bold text-[#C9A227]">€ {(effectivePrice(i) * i.qty).toFixed(2)}</span>
                        <button onClick={() => remove(i.product_id)} data-testid={`cart-remove-${i.slug}`} className="p-1.5 text-[#9CA3AF] hover:text-[#DC2626]"><Trash2 size={14} /></button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="p-5 border-t border-[#C9A227]/20 space-y-3 bg-[#08080a]">
              <div className="flex justify-between text-sm text-[#9CA3AF]">
                <span>Subtotale</span><span className="font-mono-ps text-white">€ {subtotal.toFixed(2)}</span>
              </div>
              <div className="text-[10px] font-mono-ps text-[#9CA3AF] tracking-widest uppercase">
                Spedizione da scegliere in checkout (Vinted €0 · BRT €10 · BRT assicurata €30)
              </div>
              {balance > 0 && (
                <div className="flex justify-between text-xs text-[#C9A227] border-t border-[#C9A227]/15 pt-2">
                  <span>Saldo alla conferma (allocazione)</span><span className="font-mono-ps">€ {balance.toFixed(2)}</span>
                </div>
              )}
              <div className="flex justify-between font-display text-lg font-bold pt-2 border-t border-[#C9A227]/15">
                <span className="text-white">Da pagare oggi</span>
                <span className="text-[#C9A227] font-mono-ps">€ {subtotal.toFixed(2)}</span>
              </div>
              <button
                data-testid="cart-checkout"
                onClick={() => { setOpen(false); navigate("/checkout"); }}
                className="btn-gold w-full justify-center"
              >
                Vai al checkout <ArrowRight size={16} />
              </button>
            </div>
          </>
        )}
      </aside>
    </div>
  );
};
